<template>
  <div class="extraction-field-group-header">
    <v-row
      no-gutters
      class="grey lighten-4 pa-2 subtitle-2 grey--text text--darken-2 font-weight-bold text-center"
      justify="center"
      align="center"
    >
      <slot></slot>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ExtractionFieldGroupHeader',
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.extraction-field-group-header {
  border-bottom: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
